import img1 from '../../../Components/CameraFrontGuideModal/image/1.svg';
import img2 from '../../../Components/CameraFrontGuideModal/image/2.svg';
import img3 from '../../../Components/CameraFrontGuideModal/image/3.svg';
import img4 from '../../../Components/CameraFrontGuideModal/image/4.svg';
import img5 from '../../../Components/CameraFrontGuideModal/image/5.svg';
import img6 from '../../../Components/CameraFrontGuideModal/image/6.svg';

export const cameraSteps = [
  {
    label: img1,
    description: `گوشی را مقابل صورت خود ثابت نگهدارید و
                            مطابق نمونه صورت شما باید بدون هیچ سایه و
                            اختلالی در تصویر باشد`,
  },
  {
    label: img2,
    description: 'نور از پشت سر تابیده نشود تا چهره ی شما تاریک (ضد نور) نشود',
  },
  {
    label: img3,
    description: `صورت در حالت نیم  سایه نبوده و
                            کل چهره واضح و قابل تشخیص باشد`,
  },
  {
    label: img4,
    description: `محیط مه آلود یا غبار آلود نباشد`,
  },
  {
    label: img5,
    description: `دست در هنگام عکس گرفتن نلرزد
                            تا تصویر محو نشود`,
  },
  {
    label: img6,
    description: `لطفا شئونات اسلامی را رعایت کرده و حجاب خود را بطور کامل حفظ کنید`,
  },
];
